import { errors } from '../notification'

interface Fields {
    [key: string]: { errors: string[] }
}

export function getError(field: string, code: string) {
    const switcher = `${field}|${code}`
    switch (switcher) {
        case 'email|isUsed':
            errors.emailIsUsed()
            break
        case 'metaName|isUsed':
            errors.metaNameIsUsed()
            break
        case 'betAmount|smallBalance':
            errors.smallBalance()
            break
        default:
            break
    }
}

export function errorHandler(e: any) {
    const fields = e.response.data.fields as Fields
    const code = e.response.status as number
    // console.log({ e })
    switch (code) {
        case 422:
            Object.entries(fields).forEach((f) => {
                const [field, data] = f
                data.errors.forEach((i) => {
                    getError(field, i)
                })
            })
            return Promise.reject(e)
        default:
            return Promise.reject(e)
    }
}

export function fileError(e: any) {
    const code = e.response.status as number
    switch (code) {
        case 413:
            errors.fileIsBig()
            return Promise.reject(e)
        default:
            return Promise.reject(e)
    }
}
